import { combineReducers } from 'redux';
import formReducer from './form/form.reducer';
import componentReducer from './components/component.reducer';
import buttonReducer from './button/button';
import mcqReducer from '../redux/multipleChoice/mcq.reducer';
import flipReducer from '../redux/flipCard/form.reducer';
import parentDataReducer from './parentDataSlice';
import imageStorageReducer, { embedReducer } from './mediaManagement/images.reducer';
import singleApiCallReducer from './embedInterctive';
import typeReducer from './handleBrowserBack';

export default combineReducers({
  //combined reducers with actions
  form: formReducer,
  component: componentReducer,
  button: buttonReducer,
  mcqform: mcqReducer,
  flipform: flipReducer,
  imageStorage: imageStorageReducer,
  parentData: parentDataReducer,
  embed: embedReducer,
  singleApiCall: singleApiCallReducer,
  typeSlice: typeReducer,
});
